import * as ActionTypes from './actionTypes'

export const copyStateValue = (payload) =>
{
    return {
        type : ActionTypes.COPY_STATE_VALUE,
	      payload
    }
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/state-copier/src/actions/actions.js